"use client";

import SearchContent from "./components/search-content";
import SearchHeader from "./components/search-header";

const SearchView = () => {
  return (
    <>
      <SearchHeader />
      <SearchContent />
    </>
  );
};

export default SearchView;
